


















































































import _ from 'lodash'
import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import { IFormStore } from '@/store/types'
import { koutsuhiInputStore } from '@/store/form/KoutsuhiInputFormStore'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { KeyInfo } from '@/components/common/form/types'
import { CodeLabel, ApiGeneralSinglePayload, ApiGeneralObjectArrayPayload } from '@/tcw/api/types'
import * as ApiPath from '@/tcw/constant/ApiPath'
import { TcwAPIID } from '@/tcw/domain/types'
import { TCWApiError } from '@/plugins/TCWBaseError'
import { ERR_CODE_WEB_API_NOT_FOUND } from '@/tcw/constant/ErrorCode'
import { API_DAY_FORMAT } from '@/tcw/utils/TcwService'
import KoutsuhiKeiroCard from '@/components/koutsuhi/molecules/KoutsuhiKeiroCard.vue'
import { TCWBadDataStructureError } from '@/plugins/TCWBaseError'

@Component({
  components: { KoutsuhiKeiroCard }
})
export default class KoutsuhiInputForm extends Mixins(FormStoreComponent) {
  @Prop({ type: Date, default: () => new Date() })
  private inputDate!: Date

  protected koutsuhiPatternId: TcwAPIID = null
  protected koutsuhiPatternList: ApiGeneralObjectArrayPayload = []
  protected koutsuhiPatternLoaded = false

  @Emit()
  protected changeDate(date: Date): void {
    this.$tcw.$store.basic.setTargetDate(date)
    this.init()
  }

  get formName(): string {
    return 'koutsuhiInputForm'
  }
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return koutsuhiInputStore
  }
  get keyInfo(): KeyInfo {
    return {
      year: this.inputDate.getFullYear(),
      month: this.inputDate.getMonth() + 1,
      day: this.inputDate.getDate()
    }
  }

  get form(): ApiGeneralSinglePayload {
    return this.storeModule.editData !== null ? this.storeModule.editData : {}
  }
  /**
   * 画面初期化 後処理
   */
  protected async afterProc(): Promise<void> {
    const url = ApiPath.Paths.KoutsuhiPatternList.get
    this.koutsuhiPatternList = await this.getWebApi().call<ApiGeneralObjectArrayPayload>(url, 'GET')
    if (this.storeModule.isNewRecord) {
      this.storeModule.updateRecord({
        hasseiBi: this.du.convertDateToStr(this.inputDate, API_DAY_FORMAT)
      })
    }
    return
  }
  protected async errorProc(e: Error): Promise<void> {
    // サーバからリソースなしエラーが帰ってきた場合は、新規データを取得
    if (e instanceof TCWApiError && e.getErrorCode() === ERR_CODE_WEB_API_NOT_FOUND) {
      console.log('交通費データが未保存のためからデータを取得します')
      await this.storeModule.fetchEmpty()
      await this.afterProc()
    } else {
      this.defaultErrorProc(e)
    }
    return
  }
  protected checkSameKey(keyInfo: KeyInfo, editData: ApiGeneralSinglePayload): boolean {
    const [year, month, day]: number[] = [
      Number(keyInfo['year']),
      Number(keyInfo['month']),
      Number(keyInfo['day'])
    ]
    const targetDate: Date = new Date(year, month - 1, day)
    const hasseiBi = editData['hasseiBi']
    const storeDate = typeof hasseiBi === 'string' ? new Date(hasseiBi) : null
    return this.du.equalsDate(targetDate, storeDate)
  }

  protected get goukeiKingaku(): number {
    let goukeiKingaku = this.keiroList.reduce((sum: number, keiro) => {
      if (Number.isInteger(keiro.kingaku)) {
        sum += Number(keiro.kingaku)
      }
      return sum
    }, 0)
    return goukeiKingaku
  }

  protected get koutsuhiPatternDropDown(): CodeLabel[] {
    return this.koutsuhiPatternList.map(record => {
      return {
        code: String(record.id),
        label: String(record.patternName)
      }
    })
  }

  protected selectKoutsuhiPattern(koutsuhiPatternId: TcwAPIID): void {
    if (koutsuhiPatternId === null) {
      return
    }

    const strId = String(koutsuhiPatternId)
    let targetPattern = this.koutsuhiPatternList.find(pattern => String(pattern.id) === strId)
    if (!targetPattern) {
      return
    }
    targetPattern = _.cloneDeep(targetPattern)
    delete targetPattern.id

    // 各径路のidをnullに設定(バックエンドでidがnullのとき経路を新規登録するようにしているため)
    const keiroList = targetPattern.keiroList as ApiGeneralObjectArrayPayload
    if (_.isArray(keiroList)) {
      keiroList.forEach(keiro => (keiro.id = null))
    } else {
      this.throwError(
        new TCWBadDataStructureError('データ構造が不正です。システム管理者に問い合わせてください')
      )
    }

    this.storeModule.updateRecord(targetPattern)
    this.form.title = targetPattern.patternName
  }
  private get keiroList(): ApiGeneralObjectArrayPayload {
    if (this.form && Array.isArray(this.form.keiroList)) {
      return this.form.keiroList as ApiGeneralObjectArrayPayload
    } else {
      return []
    }
  }
  private set keiroList(keiroList: ApiGeneralObjectArrayPayload) {
    this.updateValue('keiroList', keiroList)
  }
}
